if (!customElements.get('noetic-product-card-gallery')) {
  customElements.define('noetic-product-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      if (!this.track) return;

      this.hydrate = this.hydrateDeferredImages.bind(this);
      this.updateDots = this.updateDots.bind(this);

      this.addEventListener('pointerenter', this.hydrate, { once: true, passive: true });
      this.addEventListener('pointerdown', this.hydrate, { once: true, passive: true });
      this.addEventListener('focusin', this.hydrate, { once: true, passive: true });
      this.track.addEventListener('scroll', this.updateDots, { passive: true });
    }

    disconnectedCallback() {
      if (this.track && this.updateDots) {
        this.track.removeEventListener('scroll', this.updateDots);
      }
    }

    hydrateDeferredImages() {
      this.querySelectorAll('[data-gallery-deferred-image]').forEach((image) => {
        if (image.dataset.codexSrcset) image.srcset = image.dataset.codexSrcset;
        if (image.dataset.codexSizes) image.sizes = image.dataset.codexSizes;
        if (image.dataset.codexSrc) image.src = image.dataset.codexSrc;
        image.removeAttribute('data-gallery-deferred-image');
        image.removeAttribute('data-codex-src');
        image.removeAttribute('data-codex-srcset');
        image.removeAttribute('data-codex-mobile-srcset');
        image.removeAttribute('data-codex-sizes');
      });
    }

    updateDots() {
      if (!this.track.clientWidth || this.dots.length < 2) return;
      const activeIndex = Math.min(this.dots.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    }
  });
}
